<!-- Template: Variable And Help text -->
<ng-template #variableAndHelp>
  <ng-container *ngTemplateOutlet="variableSearch"></ng-container>
</ng-template>

<!-- Template: Label -->
<ng-template #label>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Input Label</mat-label>
    <input
      matInput
      required
      [(ngModel)]="editorState.selectedItem.element_object.label"
      (blur)="updateLabel(editorState.selectedItem)" />
  </mat-form-field>
</ng-template>

<!-- Template: Required/Readonly -->
<ng-template #requiredReadonly>
  <div class="flex-container" style="gap: 1rem">
    <div class="flex-cell">
      <mat-checkbox [(ngModel)]="editorState.selectedItem.element_object.required" style="margin-bottom: 0;">Required</mat-checkbox>
    </div>
    <div class="flex-cell">
      <mat-checkbox [(ngModel)]="editorState.selectedItem.element_object.read_only" style="margin-bottom: 0;">Read-only</mat-checkbox>
    </div>
  </div>
</ng-template>

<!-- Template: Mask Function  -->
<ng-template #maskFunction>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Mask Function</mat-label>
    <mat-select [(ngModel)]="editorState.selectedItem.configuration['maskFunction']" canSelectNullableOptions>
      @for (mask of MaskFunctionOptions; track mask.value) {
        <mat-option [value]="mask.value">
          {{ mask.label }}
        </mat-option>
      }

      <mat-option [value]="null">
        None
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>


<!-- Template: Question -->
<ng-template #question>
  <mat-form-field appearance="outline" floatLabel="always" class="field-question">
    <mat-label>Question</mat-label>
    <textarea matInput [(ngModel)]="editorState.selectedItem.element_object.tooltip"></textarea>
    <button mat-button color="primary-light" (click)="openHelpContentDialog(editorState.selectedItem)">Edit</button>
  </mat-form-field>

  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Question Location</mat-label>
    <mat-select [(ngModel)]="editorState.selectedItem.configuration['questionLocation']">
      <mat-option value="above">
        Above
      </mat-option>
      <mat-option value="below">
        Below
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<!-- Group Options -->
<ng-template #groupSection>
  <section class="option-fields">
    <h4>Group Options</h4>

    <div class="groups-container">
      <mat-form-field appearance="outline" floatLabel="always" class="group-id">
        <mat-label>Group ID</mat-label>
        <input
        matInput
        required
        [(ngModel)]="editorState.selectedItem.configuration['groupId']"
        />
        <mat-hint>Elements sharing a Group ID will be horizontally grouped</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="group-id-existing">
        <mat-label>Existing Groups</mat-label>
        <mat-select (selectionChange)="editorState.selectedItem.configuration['groupId'] = $event.value" [value]="editorState.selectedItem.configuration['groupId']">
          @for (group of groups; track group) {
            <mat-option [value]="group">
              {{group}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" floatLabel="always" class="group-id">
      <mat-label>Size Ratio</mat-label>
      <input
      matInput
      required
      [(ngModel)]="editorState.selectedItem.configuration['groupSpan']"
      />
      <mat-hint>This is the ratio of this field relative to others in the same group.</mat-hint>
    </mat-form-field>
  </section>
</ng-template>

<ng-template #displayLabel>
@if (instanceOfElementOrPageObject(editorState.selectedItem)) {
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Display Label Override</mat-label>
    <input matInput [(ngModel)]="editorState.selectedItem.element_object.display_label" />
    <mat-hint class="help-text">Optionally provide a shorter description of the question for data export</mat-hint>
  </mat-form-field>
}
</ng-template>

<!-- Section Template: Visibility Options Section -->
<ng-template #visibilitySection>
  <section class="option-fields">
    <h4>Visibility Options</h4>
    <mat-form-field appearance="outline" floatLabel="always" *ngIf="instanceOfElementOrPageObject(editorState.selectedItem)">
      <mat-label>Who should see this?</mat-label>
      <mat-select [(ngModel)]="editorState.selectedItem.role"
        [class]="editorState.selectedItem.role">
        <mat-option *ngFor="let type of objectKeys(SIGNING_ACTOR_ROLE_TYPES)" [value]="SIGNING_ACTOR_ROLE_TYPES[type]" [class]="SIGNING_ACTOR_ROLE_TYPES[type] + ' color-swatch '">
          {{type}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="conditional-visibility">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Visibility Logic</mat-label>
        <mat-select
          [value]="editorState.selectedItem.visibility_key ? 'conditional' : this.editorState.selectedItem.conditionalVisibility === 'conditional' ? 'conditional' : 'always'"
          (selectionChange)="onChangeFormVariableVisibilitySelect($event)"
        >
          <mat-option value="always"> Always visible </mat-option>
          <mat-option value="conditional"> Visible based on variable </mat-option>
          <mat-option value="individual-joint"> Visible to Individual/Joint </mat-option>
          <mat-option value="entity-trust"> Visible to Entities/Trusts </mat-option>
          <mat-option value="joint"> Visible to Only Joint </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="checkFormVariableVisibilityIsConditional() === 'conditional'">
        <div class="conditional-options">
          <p>When the value of:</p>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Variable</mat-label>
            <input
              matInput
              (click)="documentService.inputSelected = true"
              (keyup)="onVariableKeyEvent($event, true)"
              [(ngModel)]="editorState.selectedItem.visibility_key"
              [matAutocomplete]="autocompleteVisibilitySearch"
              name="selected_item_visibility_key"
            />
            <mat-autocomplete class="fl-sidebar-custom-variable-selector" #autocompleteVisibilitySearch="matAutocomplete">
              <mat-progress-bar mode="indeterminate" *ngIf="formService.loadingVariables"></mat-progress-bar>
              <mat-option
                (click)="formService.searchCustomVariables(variable.key, '', '', '', true)"
                [value]="variable.key"
                *ngFor="let variable of formService.formVisibilityVariables"
              >
                <span class="variable">{{variable.key}}</span>
                <span class="label">{{variable.label}}</span>
                <span class="description" *ngIf="variable.description">{{ variable.description }}</span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <p>Is equal to any value:</p>


          <ul class="conditional-values-list" *ngIf="editorState.selectedItem.visibility_values.length">
            <li *ngFor="let value of editorState.selectedItem.visibility_values">
              <div class="value">{{ value }}</div>
              <i class="material-icons" (click)="removeVisibilityValue(value)">clear</i>
            </li>
          </ul>

          <!-- <p *ngIf="!editorState.selectedItem.visibility_values.length">
            No selected values, use the input below to add values
          </p> -->

          <mat-form-field appearance="outline" class="conditional-values" floatLabel="always">
            <input
              matInput
              placeholder="Enter value"
              [(ngModel)]="_visibilityValue"
              (keyup)="checkAddVisibilityVariable($event)"
              (click)="documentService.inputSelected = true"
            />

            <i class="material-icons" (click)="addVisibilityValue()">add_circle</i>
          </mat-form-field>
          <!-- <p class="add-info-message">Value will not save unless you hit <i class="material-icons">add_circle</i></p> -->
        </div>

        <!--
        if document then show slide toggle for ignore_visibility_rules
        -->
      </ng-container>
    </div>
  </section>
</ng-template>

<!-- Section Template: Stamping Options Section -->
<ng-template #stampingSection>
  <section class="option-fields">
    <h4>Stamping Options</h4>

    @if (instanceOfSignature(editorState.selectedItem)) {
      <mat-slide-toggle
        color="primary"
        name="stamp_external_user_id"
        [(ngModel)]="editorState.selectedItem.stamp_external_user_id"
      >
        <p>Stamp External User ID?</p>
      </mat-slide-toggle>
      <p class="help-text">
        This will stamp an external user ID below the user's signature on the completed document.
      </p>
    }

    @if (instanceOfTextOrFixedText(editorState.selectedItem)) {
      <mat-slide-toggle
        color="primary"
        name="dynamically_resize_to_fit"
        [(ngModel)]="editorState.selectedItem.dynamically_resize_to_fit"
      >
        <p>Reduce text size?</p>
      </mat-slide-toggle>
      <p class="help-text">
        This will reduce the font size when we expect the text will be longer than the box for this element. Use only for pages at or near 8.5 inches wide.
      </p>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Format Function</mat-label>
        <mat-select
          [(ngModel)]="editorState.selectedItem.configuration['formatFunction']"
          placeholder="None"
        >
          <mat-option (click)="clearFormatFunction(editorState.selectedItem)">None</mat-option>
          <mat-option value="currency">Currency</mat-option>
        </mat-select>
      </mat-form-field>
    }
  </section>
</ng-template>

<!-- Section Template: Advanced Options -->
<ng-template #advancedOptions>
  <section class="option-fields">
    <h4>Placement Options</h4>
    <mat-form-field appearance="outline" floatLabel="always" *ngIf="!instanceOfSection(editorState.selectedItem)">
      <mat-label>Current Section</mat-label>
      <mat-select [ngModel]="currentSection" (selectionChange)="changeSection($event)">
        <ng-container *ngFor="let section of formService.form.sections">
          <mat-option [value]="section">
            {{ section.title }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" *ngIf="instanceOfPageObject(editorState.selectedItem) && editorState.selectedItemPageObject">
      <mat-label>Current Page</mat-label>
      <mat-select [ngModel]="editorState.selectedItemPageObject.document_page_id" (selectionChange)="changePage($event)">
        <ng-container *ngFor="let page of documentService.document.pages">
          <mat-option [value]="page.id"> Page {{ page.index + 1 }} </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <!-- <a class="action" (click)="deleteField()" *ngIf="editorState.selectedItemPageObject"> Remove Field </a> -->
    @if (instanceOfPageObject(editorState.selectedItem)) {
      <button mat-button color="primary" class="iconic" (click)="deleteField()">
        <i class="material-icons">delete_forever</i>
        Remove Field
      </button>
    }
  </section>

  <section class="option-fields" *ngIf="instanceOfElementOrPageObject(editorState.selectedItem)">
    <h4>
      Advanced Formatting Options
      <a href="https://www.notion.so/flowinc/Advanced-Formatting-89d9b18c980b4d05be12edeadb4ef7c8" title="Click here to open the formatting options documentation" target="_blank">
        <i class="material-icons">help</i>
      </a>
    </h4>
    <div>
      <div class="mock-field-outline options-container">
        <table class="optionset" style="margin: 0">
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let option of editorState.selectedItem.configuration | keyvalue">
              <td>
                <input
                  [(ngModel)]="option.key"
                  name="element_configuration_key"
                  readonly="readonly"
                  autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"/>
              </td>
              <td>
                <input [(ngModel)]="option.value"
                      name="element_configuration_value"
                      (focus)="editConfig($event, editorState.selectedItem, option)"
                      autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" (keypress)="onFormattingOptionKeyPress($event, editorState.selectedItem, option)"/>
              </td>

              <td class="action-cell">
                <a *ngIf="!option['isEditing']" class="remove" (click)="removeConfig(editorState.selectedItem, option)">
                  <i class="material-icons">clear</i>
                </a>
                <a *ngIf="option['isEditing']" class="add" (click)="addOrUpdateConfig(editorState.selectedItem, option)">
                  <i class="material-icons">check_circle</i>
                </a>
              </td>
            </tr>

            <!-- New Config Option -->
            <tr>
              <td>
                <input
                  name="element_new_configuration_key"
                  placeholder="New Key"
                  autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
                  [(ngModel)]="newConfiguration.key"
                  [formControl]="formattingKeyControl"
                  [matAutocomplete]="autocompleteFormattingKey" />
                <mat-autocomplete #autocompleteFormattingKey="matAutocomplete">
                  <mat-option *ngFor="let key of filteredFormattingKeys$ | async" [value]="key">
                    {{ key }}
                  </mat-option>
                </mat-autocomplete>
              </td>

              <td>
                <input [(ngModel)]="newConfiguration.value"
                      name="element_new_configuration_value"
                      placeholder="New Value"
                      autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" (keypress)="onFormattingOptionKeyPress($event, editorState.selectedItem, newConfiguration)"/>
              </td>
              <td class="action-cell">
                <a
                  class="add"
                  *ngIf="newConfiguration.key && newConfiguration.value; else elseDisabledAddFormattingOption"
                  (click)="addOrUpdateConfig(editorState.selectedItem, newConfiguration)">
                  <i class="material-icons">add_circle</i>
                </a>
                <ng-template #elseDisabledAddFormattingOption>
                  <a class="add disabled">
                    <i class="material-icons">add_circle</i>
                  </a>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="add-info-message">Option will not save unless you hit <i class="material-icons">add_circle</i></p>
    </div>
  </section>

  @if (instanceOfElementOrPageObject(editorState.selectedItem)) {
    <section>
      <mat-form-field appearance="outline" floatLabel="always" (click)="documentService.inputSelected = true">
        <mat-label>Internal Notes</mat-label>
        <textarea matInput [(ngModel)]="editorState.selectedItem.internal_notes"></textarea>
        <mat-hint>These notes are not visible to anyone</mat-hint>
      </mat-form-field>
    </section>
  }
</ng-template>

<!-- Template: Variable Search -->
<ng-template #variableSearch>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Variable</mat-label>
    <input
      type="hidden"
      [(ngModel)]="editorState.selectedItem.element_object.custom_variable_id"
      name="selected_item_custom_variable_id"
    />

    <input
      matInput
      required="true"
      name="custom_variable_search"
      autocomplete="off"
      [matAutocomplete]="autocompleteSearch"
      [(ngModel)]="editorState.selectedItem.element_object.custom_variable_key"
      (keyup)="onVariableKeyEvent($event)"
      (click)="documentService.inputSelected = true"
    />

    <mat-autocomplete class="fl-sidebar-custom-variable-selector" #autocompleteSearch="matAutocomplete" (click)="formService.searchCustomVariables(null)">
      <mat-option
        (click)="openCreateVariableModal(editorState.selectedItem.element_object.custom_variable_key)"
        [value]="editorState.selectedItem.element_object.custom_variable_key"
      >
        <p *ngIf="formService.formVariables.length === 0" style="margin-top: 0;">Start typing to search for variables, or</p>
        <button mat-raised-button color="primary-light">
          Create New Variable
        </button>
      </mat-option>

      <mat-progress-bar mode="indeterminate" *ngIf="formService.loadingVariables"></mat-progress-bar>

      <div class="divider small" *ngIf="formService.formVariables.length > 0"></div>

      <mat-option
        *ngFor="let variable of formService.formVariables"
        [value]="variable.key"
        (click)="onVariableBlur()"
      >
        <span class="variable">{{variable.key}}</span>
        <span class="label">{{variable.label}}</span>
        <span class="description" *ngIf="variable.description">{{ variable.description }}</span>
      </mat-option>
    </mat-autocomplete>

    <mat-hint class="help-text error" *ngIf="!editorState.selectedItem.element_object.custom_variable_id">
      All form fields require a valid variable to be assigned.
    </mat-hint>

    <mat-hint class="help-text" *ngIf="editorState.selectedItem.element_object.custom_variable_id">
      Currently assigned to ID: {{ editorState.selectedItem.element_object.custom_variable_id }}
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Default Value</mat-label>
    <input
      matInput
      [(ngModel)]="editorState.selectedItem.element_object.default_value"
      (click)="documentService.inputSelected = true"
    />
  </mat-form-field>
</ng-template>

<!-- ------------------------------------------------------ -->
<!-- INPUT FIELD OPTIONS -->

<!-- Template: Checkbox|Slidetoggle Options -->
<ng-template #booleanFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES[editorState.selectedItem.element_object.widget_type].icon }}
    </i>
    {{BOOLEAN_TITLES[editorState.selectedItem.element_object.widget_type]}}
  </h1>

  @if (editorState.selectedItem.element_object && !editorState.selectedItem.configuration['checkboxSpecialId']) {
    <section class="option-fields">
      <h4>Display Options</h4>
      <ng-container *ngTemplateOutlet="label"></ng-container>
      <ng-container *ngTemplateOutlet="question"></ng-container>
    </section>

    <section class="option-fields">
      <h4>Data Options</h4>
      <ng-container *ngTemplateOutlet="variableSearch"></ng-container>

      <mat-checkbox
        [(ngModel)]="editorState.selectedItem.element_object.read_only"
      >
        Read-only
      </mat-checkbox>

      <ng-container *ngTemplateOutlet="displayLabel"></ng-container>
    </section>

    <ng-container *ngTemplateOutlet="groupSection"></ng-container>
  } @else {
    <section class="option-fields">
      <p>This is a special checkbox and is associated to a True/False group</p>

      <button mat-button color="primary" class="iconic" (click)="selectRadioElement(editorState.selectedItem)">
        <i class="material-icons"> radio_button_checked </i>
        Select Radio Group
      </button>
    </section>
  }
</ng-template>

<!-- Template: Fixed Text Options -->
<ng-template #fixedTextFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES['fixed_text'].icon }}
    </i>
    Fixed Text
  </h1>

  <section class="option-fields">
    <p>Note: Fixed text is only stamped on the associated document, not shown in the form</p>

    <mat-form-field appearance="outline" floatLabel="always" (click)="documentService.inputSelected = true">
      <mat-label>Name</mat-label>
      <input matInput required [(ngModel)]="editorState.selectedItem.element_object.label" (blur)="updateLabel(editorState.selectedItem)">
    </mat-form-field>
  </section>

  <section class="option-fields">
    <h4>Data Options</h4>
    <ng-container *ngTemplateOutlet="variableSearch"></ng-container>

    <mat-form-field appearance="outline" floatLabel="always" *ngIf="editorState.selectedItemPageObject && editorState.selectedItemPageObject.display_format">
      <mat-label>Date Format</mat-label>
      <mat-select [(ngModel)]="editorState.selectedItemPageObject.display_format"
        (blur)="updatePageObject()">
        <mat-option *ngFor="let type of objectKeys(DATE_TYPES)" [value]="DATE_TYPES[type]">
          {{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </section>
</ng-template>

<!-- Template: Document Options -->
<ng-template #documentFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES[editorState.selectedItem.element_object.widget_type].icon }}
    </i>
    Upload
  </h1>
  <section class="option-fields">
    <ng-container *ngTemplateOutlet="label"></ng-container>
    <mat-checkbox [(ngModel)]="editorState.selectedItem.element_object.required">Required field</mat-checkbox>
    <ng-container *ngTemplateOutlet="variableAndHelp"></ng-container>
    <ng-container *ngTemplateOutlet="question"></ng-container>
  </section>
</ng-template>

<!-- Template: Signature Options -->
<ng-template #signatureFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES[editorState.selectedItem.element_object.widget_type].icon }}
    </i>
    Signature
  </h1>

  <section class="option-fields">
    <h4>Display Options</h4>
    <ng-container *ngTemplateOutlet="question"></ng-container>
  </section>

  <section class="option-fields">
    <h4>Data Options</h4>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Variable</mat-label>

      <input
        matInput
        readonly="readonly"
        name="custom_variable_search"
        value="SIGNATURE"
      />

      <mat-hint class="help-text">
        All signatures are mapped to the global signature variable
      </mat-hint>
    </mat-form-field>
  </section>
</ng-template>

<!-- Template: Enumeration Options -->
<ng-template #enumerationFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES[editorState.selectedItem.element_object.widget_type].icon }}
    </i>
    {{ ENUMERATION_TITLES[editorState.selectedItem.element_object.widget_type] }}
  </h1>

  <section class="option-fields">
    <h4>Display Options</h4>
    <ng-container *ngTemplateOutlet="label"></ng-container>
    <ng-container *ngTemplateOutlet="question"></ng-container>
  </section>

  <ng-container *ngTemplateOutlet="groupSection"></ng-container>

  <section class="option-fields">
    <h4>Data Options</h4>
    <ng-container *ngTemplateOutlet="variableSearch"></ng-container>
    <ng-container *ngTemplateOutlet="requiredReadonly"></ng-container>

    <ng-container *ngTemplateOutlet="displayLabel"></ng-container>
  </section>

  <mat-progress-bar mode="indeterminate" *ngIf="editorState.selectedItem.isSubmitting"></mat-progress-bar>

  <section>
    <h4>{{ENUMERATION_TITLES[editorState.selectedItem.element_object.widget_type]}} Items</h4>

    @if (editorState.selectedItem.element_object.custom_variable_id) {
      <div class="mock-field-outline options-container">
        <table class="draggable-optionset">
          <thead>
            <tr>
              <th></th>
              <th>Label</th>
              <th>Value</th>
              <th></th>
            </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="dropEnumerationRow($event)">
            <tr cdkDrag class="draggable-row" *ngFor="let option of editorState.selectedItem.element_object.field_options">
              <!-- Drag Handle -->
              <td>
                <i cdkDragHandle class="drag-handle material-icons" *ngIf="!formService.savingForm">drag_handle</i>
              </td>

              <!-- Label TD -->
              <td>
                <button mat-button
                  (click)="openCustomOptionDialog(editorState.selectedItem, option)"
                  color="primary-light"
                >
                  Edit Label
                </button>
              </td>

              <!-- Value TD -->
              <td>
                <input
                  (focus)="editFieldOption($event, editorState.selectedItem, option)"
                  [(ngModel)]="option.value"
                  autocapitalize="off"
                  autocomplete="off"
                  autocorrect="off"
                  name="field_option_value"
                  spellcheck="false"
                />
              </td>

              <td>
                <a *ngIf="!option.isEditing" class="remove" (click)="removeFieldOption(editorState.selectedItem, option)">
                  <i class="material-icons">clear</i>
                </a>
                <a *ngIf="option.isEditing" class="add" (click)="addOrUpdateFieldOption(editorState.selectedItem, option)">
                  <i class="material-icons">check_circle</i>
                </a>
              </td>
            </tr>
            <tr class="no-highlight">
              <td></td>
              <td>
                <input
                  [(ngModel)]="fieldOptionToAdd.raw_html"
                  (focus)="resetAllFieldOptionEditing(editorState.selectedItem)"
                  name="field_option_to_add_raw_html"
                  placeholder="New Label"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false" />
              </td>
              <td>
                <input
                  [(ngModel)]="fieldOptionToAdd.value"
                  (focus)="resetAllFieldOptionEditing(editorState.selectedItem)"
                  (keypress)="onFieldOptionKeyPress($event, editorState.selectedItem, fieldOptionToAdd)"
                  name="field_option_to_add_value"
                  placeholder="New Value"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"/>
              </td>
              <td>
                <a
                  *ngIf="fieldOptionToAdd.raw_html && fieldOptionToAdd.value; else elseDisabledAddOption"
                  class="add"
                  (click)="addOrUpdateFieldOption(editorState.selectedItem, fieldOptionToAdd)">
                  <i class="material-icons">add_circle</i>
                </a>
                <ng-template #elseDisabledAddOption>
                  <a class="add disabled">
                    <i class="material-icons">add_circle</i>
                  </a>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="add-info-message">Option will not save unless you hit <i class="material-icons">add_circle</i></p>
    } @else {
      <p>Options will be available after variable is selected</p>
    }
  </section>
</ng-template>

<!-- Template: Content Options -->
<ng-template #contentOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES['content'].icon }}
    </i>
    Content
  </h1>

  <section class="option-fields">
    <h4>Display Options</h4>

    <div class="content-title-expandable">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Content Title</mat-label>
        <input matInput [(ngModel)]="editorState.selectedItem.element_object.title" name="title" />
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="configuration-expandable">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="editorState.selectedItem.configuration.expandableContent">
          <mat-option value="false">
            Standard
          </mat-option>
          <mat-option value="true">
            Expandable
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="openContentDialog(editorState.selectedItem.element_object.raw_html)"
    >
      Edit Content
    </button>
  </section>
</ng-template>

<!-- Template: Datepicker Options -->
<ng-template #datepickerFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES[editorState.selectedItem.element_object.widget_type].icon }}
    </i>
    Datepicker
  </h1>

  <section class="option-fields">
    <h4>Display Options</h4>
    <ng-container *ngTemplateOutlet="label"></ng-container>
    <ng-container *ngTemplateOutlet="question"></ng-container>
  </section>

  <section class="option-fields">
    <h4>Data Options</h4>
    <ng-container *ngTemplateOutlet="variableSearch"></ng-container>
    <ng-container *ngTemplateOutlet="requiredReadonly"></ng-container>

    <ng-container *ngTemplateOutlet="displayLabel"></ng-container>
  </section>

  <ng-container *ngTemplateOutlet="groupSection"></ng-container>
</ng-template>

<!-- Template: Textbox Options -->
<ng-template #textboxFieldOptions>
  <h1>
    <i class="material-icons" type="element">
      {{ WIDGET_TYPES[editorState.selectedItem.element_object.widget_type].icon }}
    </i>
    {{ TEXT_TITLES[editorState.selectedItem.element_object.widget_type] }}
  </h1>

  <section class="option-fields">
    <h4>Display Options</h4>
    <ng-container *ngTemplateOutlet="label"></ng-container>
    <ng-container *ngTemplateOutlet="question"></ng-container>
  </section>

  <section class="option-fields">
    <h4>Data Options</h4>
    <ng-container *ngTemplateOutlet="variableSearch"></ng-container>

    <ng-container *ngIf="!isHiddenInput()">
      <ng-container *ngTemplateOutlet="requiredReadonly"></ng-container>
    </ng-container>

    <ng-container *ngTemplateOutlet="displayLabel"></ng-container>
    <ng-container *ngTemplateOutlet="maskFunction"></ng-container>
  </section>
</ng-template>

<!-- ------------------------------------------------------ -->
<!-- FORM AND SECTION OPTIONS -->

<!-- Template: RTD Options -->
<ng-template #rtdOptions>
  <!-- TODO: Rename this -->
  <h1>RTD</h1>

  <div class="flex-container vertical-center" style="margin-top: 15px">
    <div *ngIf="variablesMissed.length > 0">
      <p>These variables don't exist:</p>
      <button class="missing-var" *ngFor="let variable of variablesMissed" (click)="openCreateVariableModal(variable)" style="margin: 5px 5px 5px 0;">Create {{ variable }}</button>
    </div>
  </div>
</ng-template>

<!-- Template: Form Options -->
<ng-template #formOptions>
  <h1>Form</h1>

  <section class="option-fields">
    <h4>Display Options</h4>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Form Name</mat-label>
      <input
        data-testid="form-name"
        matInput
        name="title"
        required="true"
        [(ngModel)]="editorState.selectedItem.title"
      />
      @if (documentService.document) {
        <mat-hint>
          Note: This does not rename the associated document
        </mat-hint>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Display Type</mat-label>
      <mat-select
        data-testid="form-display-type"
        name="display_type"
        required="true"
        [(ngModel)]="editorState.selectedItem.display_type">
        <mat-option value="{{ FormDisplayType.Single }}"> Single Page </mat-option>
        <mat-option value="{{ FormDisplayType.Wizard }}"> Multi-page Wizard </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-slide-toggle
      data-testid="printable"
      color="primary"
      name="printable"
      style="margin-right: 10px"
      [(ngModel)]="editorState.selectedItem.printable"
    >
      <p>Display Print Button</p>
    </mat-slide-toggle>
    <p class="help-text">
      This will display a button to print the page when a person is filling out this form.
    </p>

    <h4>Assignment Options</h4>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Applies To</mat-label>
      <mat-select
        data-testid="assignable-to"
        name="assignable_to"
        [(ngModel)]="editorState.selectedItem.assignable_to"
        [required]="true"
        (selectionChange)="updateReassignable($event)"
      >
        <mat-option value="vehicle">Entity</mat-option>
        <mat-option value="investment">Investment (and Investment Account)</mat-option>
        <mat-option value="user">User</mat-option>
        <mat-option value="vehicle">Vehicle</mat-option>
      </mat-select>
      <mat-hint class="help-text">
        This denotes where values are stored. For example, if this form applies to an investment account, then
        any values submitted will be stored on that specific account
      </mat-hint>
    </mat-form-field>

    <ng-container *ngIf="editorState.selectedItem.assignable_to === 'investment'">
      <mat-slide-toggle
        color="primary"
        name="reassignable"
        style="margin-right: 10px"
        [(ngModel)]="editorState.selectedItem.reassignable"
      >
        <p>Reassignable?</p>
      </mat-slide-toggle>
      <p class="help-text">This displays the Team Member Reassignment button</p>
    </ng-container>
  </section>

  <section class="option-fields">
    <h4>Access options</h4>

    <ng-container *ngIf="!formService.form.active">
      <p>This form is not yet live and cannot be shared. Please note, that all form fields must have a variable assigned before publishing</p>
      <div class="flex-container button-container">
        <button mat-button color="primary" class="iconic" (click)="publishForm()">
          <i class="material-icons">visibility</i>
          Publish
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="formService.form.active">
      <p>This form is published and available for search. Unpublishing a form does not cancel or deactivate from any active data requests.</p>
      <div class="flex-container button-container">
        <button mat-button color="primary" class="iconic" (click)="unpublishForm()">
          <i class="material-icons">visibility_off</i>
          Unpublish
        </button>
      </div>
    </ng-container>

    <h4>Edit Options</h4>

    <p *ngIf="formService.form.unlocked_by_user">
      This form is currently <strong>editable</strong> by <strong>{{ formService.form.unlocked_by_user.email }}</strong>.
    </p>

    <button mat-button color="primary" class="iconic" *ngIf="!formService.form.unlocked_by_user" (click)="unlockForm()">
      <i class="material-icons">lock_open</i>
      Unlock for editing
    </button>

    <button mat-button color="primary" class="iconic" *ngIf="formService.form.unlocked_by_user?.id === (user$ | async).id" (click)="lockForm()">
      <i class="material-icons">lock</i>
      Lock Form
    </button>

    <h4>Other</h4>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Description</mat-label>
      <textarea
        [(ngModel)]="editorState.selectedItem.description"
        data-testid="description"
        matInput
        name="description"
      ></textarea>
    </mat-form-field>
  </section>
</ng-template>

<!-- Template: Section Options -->
<ng-template #sectionOptions>
  <h1>Selected Section</h1>
  @if (editorState.selectedItem.type === sectionType.Hidden) {
    <p>This is a special hidden section that cannot be modified.</p>
  } @else {
    <section class="option-fields">
      <h4>Display Options</h4>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Section Title</mat-label>
        <input
          matInput
          name="title"
          placeholder="Title"
          [(ngModel)]="editorState.selectedItem.title">
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Step/Tab Label</mat-label>
        <input
          matInput
          [(ngModel)]="editorState.selectedItem.subtitle">
        <mat-hint class="help-text">
          Label that is used when form is a multi-page wizard. Section Title will be used if not specified.
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>CTA Label Override</mat-label>
        <input
          matInput
          name="cta_label"
          [(ngModel)]="editorState.selectedItem.cta_label">
        <mat-hint>Custom CTA Label to replace Next/Submit when form is a multi-page wizard. Will be ignored for last section.</mat-hint>
      </mat-form-field>
    </section>

    <ng-container *ngTemplateOutlet="visibilitySection"></ng-container>
  }
</ng-template>

<!-- Template: Document Options -->
<ng-template #documentOptions>
  <h1>Document Options</h1>
  <section class="option-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Document Filename</mat-label>
      <input
        matInput
        required
        [(ngModel)]="documentService.document.title" />
      @if (formService.form) {
        <mat-hint>
          Note: This does not rename the associated form
        </mat-hint>
      }
    </mat-form-field>

    <h4>Version Options</h4>
    <div class="flex-container button-container">
      <button mat-button color="primary" (click)="openPickerForUpload()" class="iconic">
        <i class="material-icons">file_upload</i>
        Upload New Version
      </button>
      <button mat-button color="primary" (click)="downloadDocument()" class="iconic">
        <i class="material-icons">file_download</i>
        Download Current Version
      </button>
    </div>
  </section>
</ng-template>

<!-- Sidebar -->
<div class="toolbar">
  <div>&nbsp;</div>
  <fl-action-bar [actionBar]="actionBar" *ngIf="showActionbar"></fl-action-bar>
</div>
<div class="scrollable-area" cdkScrollable>
  <ng-container *ngTemplateOutlet="childTemplate"></ng-container>
  @if (instanceOfElementOrPageObject(editorState.selectedItem)) {
    <ng-container *ngTemplateOutlet="visibilitySection"></ng-container>

    @if (instanceOfGroupableObject(editorState.selectedItem)) {
      <ng-container *ngTemplateOutlet="groupSection"></ng-container>
    }

    @if (instanceOfOrHasPageObject(editorState.selectedItem)) {
      <ng-container *ngTemplateOutlet="stampingSection"></ng-container>
    }
    <ng-container *ngTemplateOutlet="advancedOptions"></ng-container>
  }
</div>
